//
//
//
//
//

import Service from '@/service/building'
import { App_User } from '@/data/user_info'
import billboard_mixin from './_billboard_mixin'
export default {
    mixins: [
        billboard_mixin
    ],
    data () {
        return {
            src: '',
            title: '',
            house: {},
            show_cover_view: false,
            show_consult: false,
            consultant_img: '',
            current_house: {}
        }
    },
    created () {
        this.getData()
    },
    watch: {
        src (link) {
            window.location.replace(link)
        }
    },
    methods: {
        async getData () {
            const { house_id, building_id, status } = this.$route.query
            const { share_by_consultant_uid } = App_User
            const data = await Service.getBuilding(building_id, {house_id, status, share_by_consultant_uid})
            this.house = data
            if (data.current_houses && data.current_houses.length) {
                this.current_house = data.current_houses[0]
            }
            this.title = data.name
            const { vr_panorama_resource } = this.house
            if (vr_panorama_resource && vr_panorama_resource.vr_panorama_url) {
                this.src = vr_panorama_resource.vr_panorama_url
            }
        }
    }
}
